/**
 * How close a competitor is to the business, as one word (#6717).
 *
 * The score is a 0-1 float; these five bands are what a reader sees, on the
 * Competitors table and in the business export, so the two cannot disagree.
 */
export function competitorProximityLabel(closeness: number): string {
  if (closeness >= 1.0) return 'Sub-brand';
  if (closeness >= 0.8) return 'Direct';
  if (closeness >= 0.5) return 'Adjacent';
  if (closeness >= 0.2) return 'Complementary';
  return 'Unrelated';
}
